/* Source-specific desktop mega menus; mobile keeps native nested disclosure. */
(() => {
  if (window.ksMegaMenuInstalled) return;
  window.ksMegaMenuInstalled = true;
  const media = matchMedia('(min-width:990px)');
  const rootSelector = '.ks-navigation>nav>ul>li>details';
  const timers = new Map();
  let ignoreFocus = false;
  const roots = () => [...document.querySelectorAll(rootSelector)];
  const rootOf = target => target?.closest?.(rootSelector);
  const cancel = root => { clearTimeout(timers.get(root)); timers.delete(root); };
  const close = root => { cancel(root); root.open = false; root.querySelectorAll('details').forEach(d => d.open = false); };
  const expand = root => {
    cancel(root);
    roots().filter(r => r !== root).forEach(close);
    root.open = true;
    root.querySelectorAll('details').forEach(d => d.open = true);
  };
  document.addEventListener('pointerover', e => {
    if (!media.matches || e.pointerType === 'touch') return;
    const root = rootOf(e.target);
    if (root) expand(root);
  });
  document.addEventListener('pointerout', e => {
    if (!media.matches || e.pointerType === 'touch') return;
    const root = rootOf(e.target);
    if (!root || (e.relatedTarget instanceof Node && root.contains(e.relatedTarget))) return;
    cancel(root);
    timers.set(root, setTimeout(() => {
      timers.delete(root);
      if (!root.matches(':hover') && !root.contains(document.activeElement)) close(root);
    }, 250));
  });
  document.addEventListener('focusin', e => {
    if (ignoreFocus) return;
    const root = rootOf(e.target);
    if (root && media.matches) expand(root);
  });
  document.addEventListener('click', e => {
    const root = rootOf(e.target);
    const summary = e.target.closest?.('summary');
    if (root && summary && e.target.closest('.ks-root-link') && (!media.matches || e.pointerType === 'touch')) {
      e.preventDefault();
      const wasOpen = root.open;
      roots().filter(r => r !== root).forEach(close);
      if (wasOpen) close(root); else if (media.matches) expand(root); else root.open = true;
    } else if (media.matches && root && summary && !e.target.closest('a')) {
      e.preventDefault(); expand(root);
    }
    if (!root) roots().forEach(close);
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const root = rootOf(e.target);
    roots().forEach(close);
    if (root) { ignoreFocus = true; root.querySelector(':scope>summary')?.focus(); ignoreFocus = false; }
    e.preventDefault();
  });
  media.addEventListener('change', () => roots().forEach(close));
  document.addEventListener('shopify:section:load', () => roots().forEach(close));
})();
